/**
 * Safe localStorage wrapper
 *
 * localStorage can throw in Safari private browsing, when quota is exceeded,
 * or when storage is disabled by the user. This wrapper handles errors gracefully.
 */

import { logger } from '../logger';

export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      logger.warn('Cross-tab sync: localStorage.getItem failed', e);
      return null;
    }
  },

  setItem(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      logger.warn('Cross-tab sync: localStorage.setItem failed', e);
      return false;
    }
  },

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      logger.warn('Cross-tab sync: localStorage.removeItem failed', e);
    }
  },
};

export const safeSessionStorage = {
  getItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      logger.warn('Cross-tab sync: sessionStorage.getItem failed', e);
      return null;
    }
  },

  setItem(key: string, value: string): boolean {
    try {
      sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      logger.warn('Cross-tab sync: sessionStorage.setItem failed', e);
      return false;
    }
  },

  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      logger.warn('Cross-tab sync: sessionStorage.removeItem failed', e);
    }
  },
};
